import React from 'react';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormControl, InputLabel } from '@mui/material';

export default function SelectWithOptions({
  label,
  onChange = () => {},
  value,
  options = [],
  name,
  sx = {},
  size = 'small',
}) {
  return (
    <FormControl
      fullWidth
      sx={{
        maxWidth: '250px',
        ...sx,
      }}
    >
      {label && (
        <InputLabel size={size} id='demo-simple-select-label'>
          {label}
        </InputLabel>
      )}
      <Select
        labelId='demo-simple-select-label'
        id='demo-simple-select'
        value={value}
        size={size}
        label={label}
        onChange={onChange}
        name={name}
      >
        {options.map((item) => (
          <MenuItem
            size={size}
            key={item.key}
            value={item.value}
            disabled={item?.disabled}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
